module.exports = __webpack_public_path__ + "img/2.a99e208a.png";